module.exports = __webpack_public_path__ + "assets/icons/ic_person-87a2.svg";